import { render, staticRenderFns } from "./pivotChargeCollaborator.vue?vue&type=template&id=12839e20&scoped=true"
import script from "./pivotChargeCollaborator.vue?vue&type=script&lang=js"
export * from "./pivotChargeCollaborator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12839e20",
  null
  
)

export default component.exports